import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para injetar token JWT em toda request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor para tratar erros globalmente
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// ============================================================================
// AUTENTICAÇÃO
// ============================================================================

export const authAPI = {
  login: (username, password) => api.post('/auth/login', { username, password }),
  checkAuth: () => api.get('/auth/check'),
};

// ============================================================================
// CLIENTES
// ============================================================================

export const clientesAPI = {
  listar: (page = 1, perPage = 10, search = '') => {
    const params = { page, per_page: perPage };
    if (search) {
      params.search = search;
    }
    return api.get('/clientes', { params });
  },
  buscar: (id) => api.get(`/clientes/${id}`),
  verificarCpfCnpj: (cpfCnpj) => api.get(`/clientes/cpf/${cpfCnpj}`),
  criar: (dados) => api.post('/clientes', dados),
  atualizar: (id, dados) => api.put(`/clientes/${id}`, dados),
  deletar: (id) => api.delete(`/clientes/${id}`),
};

// ============================================================================
// DOCUMENTOS
// ============================================================================

export const documentosAPI = {
  listar: (clienteId) => api.get(`/clientes/${clienteId}/documentos`),
  upload: (clienteId, formData) => {
    return api.post(`/clientes/${clienteId}/documentos`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  download: (documentoId) => {
    return api.get(`/documentos/${documentoId}/download`, {
      responseType: 'blob',
    });
  },
  deletar: (documentoId) => api.delete(`/documentos/${documentoId}`),
};

// ============================================================================
// STATUS
// ============================================================================

export const statusAPI = {
  buscar: (clienteId) => api.get(`/clientes/${clienteId}/status`),
  criar: (clienteId, status) => api.post(`/clientes/${clienteId}/status`, { status }),
  deletar: (statusId) => api.delete(`/status/${statusId}`),
};

export default api;
